// generated by genversion
export var version = '3.5.0';
//# sourceMappingURL=version.js.map